import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";

import OrderType1View from "../../../../Site/Order/OrderHistory/OrderItem/OrderTypeView/OrderType1View";
import OrderType3View from "../../../../Site/Order/OrderHistory/OrderItem/OrderTypeView/OrderType3View";


class ViewItemDetails extends Component {

    constructor(props) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false,
        };
    }

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({show: true});
    };

    render() {
        let pcbParams = {};
        let stencilParams = {};

        if(this.props.itemDetails.quotation.orderType === 1){
            pcbParams = this.props.itemDetails.quotation.pcbParam;
        }else if(this.props.itemDetails.quotation.orderType === 2){
            pcbParams = this.props.itemDetails.quotation.pcbParam;
            stencilParams =this.props.itemDetails.quotation.stencilParam;
        }else{
            stencilParams = this.props.itemDetails.quotation.stencilParam;
        }

        return (
            <span>
                <a className="btn btn-xs btn-primary" onClick={this.handleShow}>
                                <FormattedMessage id="app.admin.single.order.View"
                                                  defaultMessage="View"
                                                  description=""/>
                </a>
                <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="product-details-modal">
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.order.history.item.product-details"
                                              defaultMessage="Product Details"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            {this.props.orderType=== 1 &&
                            <div>
                                <div className="row">
                                    <div className="col-md-offset-1 detail-title">
                                        {/*<b><FormattedMessage id="app.order.history.item.pcb"*/}
                                                             {/*defaultMessage="PCB Order Details"*/}
                                                             {/*description=""/></b>*/}
                                    </div>

                                </div>
                                <div className="spacer"></div>
                                <OrderType1View
                                    pcbParams={pcbParams}
                                    itemDetails={this.props.itemDetails}/>
                            </div>

                            }
                            {this.props.orderType=== 2 &&
                            <div>
                                <div className="row">
                                    <div className="col-md-offset-1 detail-title">
                                        <b><FormattedMessage id="app.order.history.item.both"
                                                             defaultMessage="PCB/Stencil Order Details"
                                                             description=""/></b>
                                    </div>

                                </div>
                                <div className="spacer"></div>
                                <OrderType1View
                                    pcbParams={pcbParams}
                                    itemDetails={this.props.itemDetails}/>
                                <OrderType3View
                                    smtStencilParams={stencilParams}
                                    itemDetails={this.props.itemDetails}/>
                            </div>

                            }

                            {this.props.orderType=== 3 &&
                            <div>
                                <div className="row">
                                    <div className="col-md-offset-1 detail-title">
                                        <b><FormattedMessage id="app.order.history.item.stencil"
                                                             defaultMessage="Stencil Order Details"
                                                             description=""/></b>
                                    </div>

                                </div>
                                <div className="spacer"></div>
                                <OrderType3View
                                    smtStencilParams={stencilParams}
                                    itemDetails={this.props.itemDetails}/>
                            </div>

                            }
                        </div>


                    </Modal.Body>
                    <Modal.Footer>

                        <button className="btn btn-primary " onClick={this.handleClose}>
                            閉じる

                        </button>

                    </Modal.Footer>
                </Modal>
            </span>
        )
    }

}
export default ViewItemDetails;


// WEBPACK FOOTER //
// ./src/components/Admin/Sales/ViewSingleCustomerSale/ViewItemDetails/ViewSalesItemDetails.js